import { Cancel, MoreHoriz } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { useState } from "react";
import EditContent from "@/components/EditContent";

export default function ActionDrawer({ content }) {
  const [open, setOpen] = useState(false);
  const [activeContent, setActiveContent] = useState(content);

  const handleOpen = () => {
    setActiveContent(content);
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Box>
      <IconButton
        onClick={handleOpen}
        style={{ marginLeft: "5px" }}
        disabled={!content}
      >
        <MoreHoriz style={{ color: "white" }} />
      </IconButton>

      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
        elevation={4}
        PaperProps={{
          style: {
            maxHeight: "90vh", // Ensure drawer doesn't take full screen if content is long
            minHeight: "60vh",
          },
        }}
      >
        {activeContent && (
          <>
            <AppBar
              position="sticky"
              elevation={0}
              color="transparent"
              sx={{ my: 2 }}
            >
              <Toolbar
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <IconButton onClick={handleCancel} color="info">
                  <Cancel />
                </IconButton>
                {activeContent.type === "audio" && (
                  <Typography variant="h6" color="info">
                    {activeContent.meta.title}
                  </Typography>
                )}
                <Box sx={{ width: "60px" }} />
              </Toolbar>
            </AppBar>

            <EditContent
              content={activeContent}
              onClose={() => setOpen(false)}
            />
          </>
        )}
      </Drawer>
    </Box>
  );
}
